import {
  validateEmail,
  validateRequired,
  validateWebstoreUrl,
  Validator,
} from 'application/utils/validators';

// <SET_IS_MODULE_LOADED>
export const SET_IS_MODULE_LOADED = '[form] sec-shotr module/isModuleLoaded';
export type SetIsModuleLoadedAction = {
  type: typeof SET_IS_MODULE_LOADED,
};
export const setIsModuleLoaded = {
  type: SET_IS_MODULE_LOADED,
};
// </SET_IS_MODULE_LOADED>

// <SUBMIT_FORM_SEC_SHORT>
export const SUBMIT_FORM_SEC_SHORT = '[form] submit 1st step sec short';
export type SubmitForm = {
  type: typeof SUBMIT_FORM_SEC_SHORT;
}
export const submitForm = {
  type: SUBMIT_FORM_SEC_SHORT,
};
// </SUBMIT_FORM_SEC_SHORT>

// <RESET_FORM_SEC_SHORT>
export const RESET_FORM_SEC_SHORT = '[sec-callback] SEC short form reset';
export type ResetForm = {
  type: typeof RESET_FORM_SEC_SHORT,
};

export const resetForm: ResetForm = {
  type: RESET_FORM_SEC_SHORT,
};
// </RESET_FORM_SEC_SHORT>

// <SET_FORM_LOADING_SEC_SHORT>
export const SET_FORM_LOADING_SEC_SHORT = '[forms] set loading sec short';
export type SetFormLoading = {
  type: typeof SET_FORM_LOADING_SEC_SHORT;
  payload: {
    isLoading: boolean;
  }
};

export const setFormLoading = (
  isLoading: boolean,
): SetFormLoading => ({
  type: SET_FORM_LOADING_SEC_SHORT,
  payload: {
    isLoading,
  },
});
// </SET_FORM_LOADING_SEC_SHORT>

// <SET_FORM_SUCCESS_SEC_SHORT>
export const SET_FORM_SUCCESS_SEC_SHORT = '[forms] set success sec short';
export type SetFormSuccess = {
  type: typeof SET_FORM_SUCCESS_SEC_SHORT;
  payload: {
    isSuccess: boolean;
  }
};

export const setFormSuccess = (
  isSuccess: boolean,
): SetFormSuccess => ({
  type: SET_FORM_SUCCESS_SEC_SHORT,
  payload: {
    isSuccess,
  },
});
// </SET_FORM_SUCCESS_SEC_SHORT>

// <SET_INPUT_SEC_SHORT>
export const SET_INPUT_SEC_SHORT = '[forms] input change sec short';

export type SetInput = {
  type: typeof SET_INPUT_SEC_SHORT;
  payload: {
    fieldName: string;
    value: string;
    validators: Validator[];
  }
}
export type SetInputValidated = {
  type: typeof SET_INPUT_SEC_SHORT;
  payload: {
    [fieldName: string]: {
      value: string;
      error: string;
    }
  }
}

export const setRequiredInput = (fieldName: string) => (
  value: string,
): SetInput => ({
  type: SET_INPUT_SEC_SHORT,
  payload: {
    fieldName,
    value,
    validators: [validateRequired],
  },
});

export const setRequiredWebstoreUrl = (fieldName: string) => (
  value: string,
): SetInput => ({
  type: SET_INPUT_SEC_SHORT,
  payload: {
    fieldName,
    value,
    validators: [validateRequired, validateWebstoreUrl],
  },
});

export const setRequiredEmail = (fieldName: string) => (
  value: string,
): SetInput => ({
  type: SET_INPUT_SEC_SHORT,
  payload: {
    fieldName,
    value,
    validators: [validateRequired, validateEmail],
  },
});
// </SET_INPUT_SEC_SHORT>

// <SET_PHONE_INPUT_SEC_SHORT>
// eslint-disable-next-line max-len
export const SET_PHONE_INPUT_SEC_SHORT = '[forms] phone number change sec short';
export type SetPhoneInput = {
  type: typeof SET_PHONE_INPUT_SEC_SHORT;
  payload: {
    countryCode: string;
    number: string;
    isRequired: boolean;
  }
}
export type SetPhoneInputValidated = {
  type: typeof SET_PHONE_INPUT_SEC_SHORT;
  payload: {
    phoneNumber: {
      countryCode: string;
      number: string;
      error: string;
    };
  }
}

export const setRequiredPhoneInput = (
  countryCode: string,
  number: string,
): SetPhoneInput => ({
  type: SET_PHONE_INPUT_SEC_SHORT,
  payload: {
    countryCode,
    number,
    isRequired: true,
  },
});
// </SET_PHONE_INPUT_SEC_SHORT>

// <SET_CHECKBOX_SEC_SHORT>
export const SET_CHECKBOX_SEC_SHORT = '[forms] checkbox change sec short';

export type SetCheckbox = {
  type: typeof SET_CHECKBOX_SEC_SHORT,
  payload: {
    groupName: string,
    option: string,
    isChecked: boolean,
    validators: Validator[],
  }
}

export type SetCheckboxValidated = {
  type: typeof SET_CHECKBOX_SEC_SHORT;
  payload: {
    [groupName: string]: {
      value: { [key: string]: boolean; };
      error: string;
    }
  }
}

export const setCheckbox = (
  groupName: string,
  option: string,
) => (
  isChecked: boolean,
): SetCheckbox => ({
  type: SET_CHECKBOX_SEC_SHORT,
  payload: {
    groupName,
    option,
    isChecked,
    validators: [],
  },
});
// </SET_CHECKBOX_SEC_SHORT>

// <SET_GENERAL_ERROR_SEC_SHORT>
export const SET_GENERAL_ERROR_SEC_SHORT = 'set general error sec short';
export type SetGeneralErrorMessage = {
  type: typeof SET_GENERAL_ERROR_SEC_SHORT;
  payload: string;
}

export const setGeneralErrorMessage = (
  message: SetGeneralErrorMessage['payload'],
): SetGeneralErrorMessage => ({
  type: SET_GENERAL_ERROR_SEC_SHORT,
  payload: message,
});
// </SET_GENERAL_ERROR_SEC_SHORT>

// <SHOW_SECOND_STEP_SEC_SHORT>
export const SHOW_SECOND_STEP_SEC_SHORT = '[forms] show 2nd step sec short';

export type ShowSecondStep = {
  type: typeof SHOW_SECOND_STEP_SEC_SHORT,
};
export const showSecondStep = {
  type: SHOW_SECOND_STEP_SEC_SHORT,
};
// </SHOW_SECOND_STEP_SEC_SHORT>

// <SET_CAMPAIGN_SEC_SHORT>
export const SET_CAMPAIGN_SEC_SHORT = 'set campaign data sec short';
export type SetCampaign = {
  type: typeof SET_CAMPAIGN_SEC_SHORT,
  payload: {
    name: string,
    source: string,
    medium: string,
  }
}
export const setCampaign = (
  campaign: SetCampaign['payload'],
): SetCampaign => ({
  type: SET_CAMPAIGN_SEC_SHORT,
  payload: campaign,
});
// </SET_CAMPAIGN_SEC_SHORT>

export type SecCallbackActions =
  | SetIsModuleLoadedAction
  | SetInputValidated
  | SetPhoneInputValidated
  | SetCheckboxValidated
  | SetCampaign
  | SetFormLoading
  | SetFormSuccess
  | ShowSecondStep
  | SetGeneralErrorMessage
  | ResetForm;
